/** A definition id from a URL: a positive whole number, or null for anything else. */
export const parseDefinitionId = (raw: string | null | undefined): number | null => {
  if (raw == null || !/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};
